import React from 'react'
import { StyleSheet, View } from 'react-native'

import Loading from '@/components/Mini/Loading'

import * as cth from '@/router/(root)/cth/cthModule'
import { CthHeader as Header } from '@/components/Mini/Header'
import { CthBackground as Background } from '@/components/Mini/Background'
import { CthLeaderboardCard as LeaderboardCard } from '@/components/Mini/LeaderboardCard'

export function CthLeaderboardScreen() {
  const { status } = cth.useCthQueryStatus()
  const { leaderboard } = cth.useCthQueryLeaderboard()
  const handleClose = cth.useHandleClose()
  const theme = cth.useStore((s) => s.theme)

  const loading = leaderboard && status ? false : true
  //const loading = true;

  return (
    <Background>
      <Header title="Today's Leaderboard" handler={handleClose} />

      {loading && <Loading color={theme.accent} />}

      {!loading && (
        <View style={styles.content}>
          <LeaderboardCard />
        </View>
      )}
    </Background>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
    paddingBottom: 24
  },
  content: {
    flex: 1,
    paddingHorizontal: 16
  }
})
